import { useId } from '@magnetic/hooks';
import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const GroupListItem = /* @__PURE__ */ __name(({
  children
}) => /* @__PURE__ */ React.createElement("li", {
  className: "mds-rebuild-tag-group-item",
  key: useId()
}, children), "GroupListItem");

export { GroupListItem };
//# sourceMappingURL=group-list-item.js.map
